import { useState } from 'react';
import type { AdvisorVersion, AdvisorVersionMeta } from '@agio/core/domain';
import { Card, EmptyState } from '../../Card.js';
import { Table, THeadRow, TH, TD, TR, Ltr } from '../../ui/table.js';
import { Modal } from '../../ui/modal.js';
import { ErrorBanner } from '../../FormBits.js';
import { AdvisorRichText } from '../../advisor/AdvisorRichText.js';
import { advisor, fmtWhen } from './advisorApi.js';

/** Every saved version of the main summary, newest first; any one can be opened to read. */
export function VersionsList({ versions }: { versions: AdvisorVersionMeta[] | null }) {
  const [open, setOpen] = useState<AdvisorVersion | null>(null);
  const [error, setError] = useState<string | null>(null);
  const view = async (n: number) => {
    setError(null);
    try { setOpen(await advisor.version(n)); } catch (e) { setError((e as Error).message); }
  };

  return (
    <Card title="גרסאות">
      <ErrorBanner error={error} title="לא ניתן לפתוח את הגרסה" />
      {versions !== null && versions.length === 0 && <EmptyState label="עדיין לא נשמרה אף גרסה" />}
      {versions !== null && versions.length > 0 && (
        <Table minWidth="22rem">
          <THeadRow>
            <TH>גרסה</TH>
            <TH>נשמרה</TH>
            <TH>על ידי</TH>
            <TH />
          </THeadRow>
          <tbody>
            {versions.map((v) => (
              <TR key={v.version}>
                <TD className="font-semibold tabular-nums">{v.version}</TD>
                <TD><Ltr>{fmtWhen(v.createdAt)}</Ltr></TD>
                <TD><Ltr className="text-xs">{v.createdBy}</Ltr></TD>
                <TD align="end">
                  <button type="button" onClick={() => view(v.version)} className="rounded-md border border-border px-3 py-1 text-sm hover:bg-muted">
                    צפייה
                  </button>
                </TD>
              </TR>
            ))}
          </tbody>
        </Table>
      )}
      <Modal
        open={open !== null}
        size="lg"
        title={open ? `גרסה ${open.version}` : ''}
        description={open ? `נשמרה ${fmtWhen(open.createdAt)} על ידי ${open.createdBy}` : undefined}
        onClose={() => setOpen(null)}
      >
        {open && <AdvisorRichText doc={open.body} />}
      </Modal>
    </Card>
  );
}
